import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';
import { ReleaseComponent, ReleaseComponentApi } from 'types/releaseComponent';

/**
 * コンポーネント一覧画面の状態
 */
interface ListState {
  /**
   * ロード中フラグ
   */
  loading: boolean;
  /**
   * コンポーネント一覧
   */
  releaseComponents: ReleaseComponent[];
  /**
   * 選択されたリリース
   */
  selectedReleaseComponent: ReleaseComponent | undefined;
}

/**
 * コンポーネント一覧画面の初期状態
 */
const initialState: ListState = {
  loading: false,
  releaseComponents: [],
  selectedReleaseComponent: undefined,
};

/**
 * コンポーネント画面の slice(reducer + action)
 */
export const listSlice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    init: () => initialState,
    loadStarted: (state) => {
      state.loading = true;
    },
    loadEnded: (state) => {
      state.loading = false;
    },
    fetchReleaseComponentSuccess: (
      state,
      action: PayloadAction<{
        releaseComponents: ReleaseComponentApi[];
      }>,
    ) => {
      const { releaseComponents } = action.payload;
      // react-hook-formのformData(array)に対応するためにデータを加工
      const ReleaseComponentForm: ReleaseComponent[] = releaseComponents.map(
        (apiData: ReleaseComponentApi) => ({
          id: apiData.id,
          componentName: apiData.componentName,
          repositoryUrl: apiData.repositoryUrl,
          manifestName: apiData.manifestName,
          targetKeys: apiData.targetKeys.map((targetKey: string) => ({
            value: targetKey,
          })),
        }),
      );
      state.releaseComponents = ReleaseComponentForm;
    },
  },
});

/**
 * コンポーネント一覧画面の action
 */
export const listActions = listSlice.actions;

/**
 * コンポーネント一覧画面の selector（内部用）
 */
const getloading = (state: RootState) => state.releaseComponent.list.loading;

const getReleaseComponents = (state: RootState) =>
  state.releaseComponent.list.releaseComponents;

/**
 * コンポーネント一覧画面の selector
 */
export const listSelectors = {
  loading: getloading,
  releaseComponents: getReleaseComponents,
} as const;
